// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: process.env.GATSBY_AWS_REGION,
  aws_cognito_identity_pool_id: process.env.GATSBY_IDENTITY_POOL,
  aws_cognito_region: process.env.GATSBY_AWS_REGION,
  aws_user_pools_id: process.env.GATSBY_USER_POOL,
  aws_user_pools_web_client_id: process.env.GATSBY_CLIENT_ID,
  oauth: {
    domain: process.env.GATSBY_OAUTH_DOMAIN,
    scope: [
      'phone',
      'email',
      'openid',
      'profile',
      'aws.cognito.signin.user.admin',
    ],
    redirectSignIn: 'https://app.promazo.com',
    redirectSignOut: 'https://mimino.promazo.com',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_AND_IDENTITY_POOLS',
  aws_cloud_logic_custom: [
    {
      name: 'proxyCORSRequestsApi',
      endpoint: process.env.GATSBY_CORS_ENDPOINT,
      region: process.env.GATSBY_AWS_REGION,
    },
  ],
}
export default awsmobile
